import { ApiClient, ApiError, ApiErrorCode } from '@bustickus/api';
import {
  IClientPaymentTicketsBookingPost,
  IClientPaymentPost,
  IClientPaymentPostBrief,
  IClientTripPriceCalculationFull,
  IClientTripPriceCalculationPost,
} from '@bustickus/models-client';
import { createApiAddress } from 'common/helpers';
import { AuthService } from 'common/services';

class ApiPayment {
  private readonly client: ApiClient = ApiClient.getInstance();
  private static instance: ApiPayment | null = null;

  private constructor() {}

  static getInstance(): ApiPayment {
    if (ApiPayment.instance == null) {
      ApiPayment.instance = new ApiPayment();
    }

    return ApiPayment.instance;
  }

  async calculate(request: IClientTripPriceCalculationPost[]): Promise<IClientTripPriceCalculationFull> {
    const jwt = this.jwt();
    const address = createApiAddress('/client/payments/calculate');
    const response = await this.client.sendRequest<IClientTripPriceCalculationFull>('post', address, request, jwt);
    return response;
  }

  async buy(tripPasengers: { [tripId: string]: IClientPaymentTicketsBookingPost[] }) {
    const jwt = this.jwt();
    const address = createApiAddress('/client/payments');
    const request: IClientPaymentPost = {
      tripPassengers: tripPasengers,
    };

    const response = await this.client.sendRequest<IClientPaymentPostBrief>('post', address, request, jwt);

    return response;
  }

  private jwt() {
    const authService = AuthService.getInstance();
    const jwt = authService.get();

    if (jwt == null) {
      throw new ApiError(ApiErrorCode.Unauthorized);
    }

    return jwt;
  }
}

export default ApiPayment;
